import { Fragment } from 'react';
import classes from './Modal.module.css';
import ReactDOM from 'react-dom';

const Backdrop = (props) => {
  return <div className={classes.backdrop} onClick={props.atf}></div>;
};

const ModalOverlay = (props) => {
  return (
    <div className={classes.modal}>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};
// ----------------------------------------------------------------------------------------------------

const popupUsingPortalViaReactDOM = document.getElementById('overlays');

const Modal = (props) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop atf={props.viaBackDrop} />,
        popupUsingPortalViaReactDOM
      )}

      {ReactDOM.createPortal(
        <ModalOverlay>{props.children}</ModalOverlay>,
        popupUsingPortalViaReactDOM
      )}
    </Fragment>
  );
};

export default Modal;
